<script>
import AuthorizationCategoryComboBox from './AuthorizationCategoryComboBox'
import CallToActionComboBox from './CallToActionComboBox'

export default {
  name: 'AdCreativeSettingsForm',
  components: {
    AuthorizationCategoryComboBox,
    CallToActionComboBox
  },
  computed: {
    useEventImage: {
      get() {
        return this.formData.useEventImage
      },
      set(value) {
        this.update('useEventImage', value)
      }
    }
  },
  props: {
    value: { type: Object, required: true }
  },
  data() {
    return {
      formData: this.value
    }
  },
  methods: {
    update(field, value) {
      this.formData[field] = value
      this.$emit('input', this.formData)
    }
  },
  watch: {
    value: function(oldValue, newValue) {
      this.formData = newValue
    }
  }
}
</script>

<template>
  <v-form>
    <authorization-category-combo-box
      :value="formData.authorizationCategory"
      @input="update('authorizationCategory', $event)"
    />
    <call-to-action-combo-box :value="formData.callToAction" @input="update('callToAction', $event)" />
    <v-text-field
      :value="formData.urlTags"
      @input="update('urlTags', $event)"
      label="URL Parameters"
      placeholder="URL Parameters"
    />
    <v-checkbox v-model="useEventImage" label="Use event image" />
  </v-form>
</template>
